// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1s6A1","icon":"SortAdornment_icon__3LbM8","up":"SortAdornment_up__3_Lps","down":"SortAdornment_down__2aZLX","active":"SortAdornment_active__1mV-m"};